let fetchedData = null;

function sortData(array, key, order = 'asc') {
    return array.slice().sort((a, b) => {
        const valA = a.sort[key];
        const valB = b.sort[key];

        if (typeof valA === 'number' && typeof valB === 'number') {
            return order === 'asc' ? valA - valB : valB - valA;
        } else {
            return order === 'asc'
                ? String(valA).localeCompare(String(valB))
                : String(valB).localeCompare(String(valA));
        }
    });
}

function handleSortClick(event) {
    const sortKey = event.currentTarget.dataset.sort;
    const sortOrder = event.currentTarget.dataset.order || 'desc'; // "asc" or "desc"
    if (!fetchedData) {
        fetch('/search?view=sorting')
            .then(res => res.json())
            .then(data => {
                fetchedData = data;
                const sorted = sortData(fetchedData, sortKey, sortOrder);
                fetchSorted(generateQueryString(sorted));
            })
            .catch(err => console.error('Fetch error:', err));
    } else {
        const sorted = sortData(fetchedData, sortKey, sortOrder);
        fetchSorted(generateQueryString(sorted));
    }
}

function generateQueryString(products) {
    const handles = products.map(product => product.handle);
    const queryString = `&products=${handles.join('+')}`;
    return queryString;
}

function fetchSorted(sorted) {

    const resultsContainer = document.getElementById("ajax-search-results");
    const productGrid = document.getElementById("ProductGridContainer");

    fetch('/search?view=sorting&type=2' + sorted)
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.text(); 
    })
    .then(html => {
        resultsContainer.innerHTML = `<ul class="search-products-grid grid grid--2-col-tablet-down grid--4-col-desktop">${html}</ul>`;
        productGrid.style.display = "none";
        alert();
        resultsContainer.style.display = "block";
    })
    .catch(error => {
        console.error('Fetch error:', error);
    });
}

// Attach click listeners
document.querySelectorAll('.sort-button').forEach(button => {
    button.addEventListener('click', handleSortClick);
});


document.addEventListener("DOMContentLoaded", () => {
    const input = document.getElementById("ajax-search-input");
    if(input){
      const resultsContainer = document.getElementById("ajax-search-results");
      const productGrid = document.getElementById("product-grid");
      let debounce;
      input.addEventListener("input", function() {
          const query = this.value.trim();
          clearTimeout(debounce);
          if(query.length < 2){
              resultsContainer.style.display = "none";
              productGrid.style.display = "flex";
              resultsContainer.innerHTML = "";
              return;
          }
          debounce = setTimeout(() => {
              fetch(`/search?q=${encodeURIComponent(query)}&section_id=ajax-search-products&type=product`)
              .then(res => res.text())
              .then(html => {
                  resultsContainer.innerHTML = html;
                  productGrid.style.display = "none";
                  resultsContainer.style.display = "block";
              });
          }, 300);
      });
    }
});

class FacetSortDropdown extends HTMLElement {
  constructor() {
    super();
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.onSortClick = this.onSortClick.bind(this);
    this.closeDropdown = this.closeDropdown.bind(this);

    this.dropdown = this.querySelector('.tfd-panel');
    this.button = this.querySelector('.sorting-dropdown__toggle');
    this.listItems = this.querySelectorAll('.sort-button');

    // Add toggle listener
    this.button.addEventListener('click', this.toggleDropdown);

    // Add sort item listeners
    this.listItems.forEach((item) => {
      item.addEventListener('click', this.onSortClick);
    });

    // Close dropdown if click outside
    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) this.closeDropdown();
    });

    // Add cross button dynamically
    this.addCloseButton();
  }

  toggleDropdown(event) {
    event.stopPropagation();
    this.dropdown.classList.toggle('open');
  }

  closeDropdown() {
    this.dropdown.classList.remove('open');
  }

  onSortClick(event) {
    event.preventDefault();
    const clickedItem = event.currentTarget;
    const sortValue = clickedItem.dataset.sort;

    // Update active class
    this.listItems.forEach((item) => item.classList.remove('active'));
    clickedItem.classList.add('active');

    // Close the dropdown
    this.closeDropdown();

    // Update search params
    let searchParams = new URLSearchParams(window.location.search);
    searchParams.set('sort', sortValue);

    const facetForm = document.querySelector('facet-filters-form');
    if (facetForm) {
      facetForm.onSubmitForm(searchParams.toString(), event);
    }
  }

  addCloseButton() {
    const crossBtn = document.createElement('button');
    crossBtn.textContent = '×';
    crossBtn.setAttribute('aria-label', 'Close');
    crossBtn.className = 'sorting-dropdown__close';
    crossBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      this.closeDropdown();
    });

    // Insert cross button at the top of the panel
    const wrapper = this.dropdown.querySelector('.tfd-panel-wrapper');
    if (wrapper) {
      wrapper.prepend(crossBtn);
    }
  }
}

customElements.define('facet-sort-dropdown', FacetSortDropdown);

class TagsFilterDropdown extends HTMLElement {
  constructor() {
    super();
    this._open = false;
    this._selectedTags = new Set();
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  connectedCallback() {
    this.render();
    this.syncFromURL();

    this.querySelector('.tfd-trigger').addEventListener('click', () => this.toggle());
    this.querySelector('.tfd-clear').addEventListener('click', () => this.clearAll());

    // Keep in sync when FacetFiltersForm updates the page (e.g. browser back/forward)
    window.addEventListener('popstate', () => this.syncFromURL());

    const closeBtn = this.querySelector('.tfd-pills-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.stopPropagation(); // Prevent triggering outside click
        this.close();
      });
    }
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleOutsideClick);
  }

  // ─── Read current tags param from URL ───────────────────────────────────
  syncFromURL() {
    const params = new URLSearchParams(window.location.search);
    this._selectedTags = new Set();

    // Shopify facet filter params look like: filter.p.tag=sale&filter.p.tag=organic
    params.getAll(this.tagParam).forEach((v) => this._selectedTags.add(v));
    this.updateUI();
  }
  // ─── Write back into FacetFiltersForm and trigger a render ──────────────
  applyFilters() {
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const parts = [];

    sortFilterForms.forEach((form) => {
      // Include sort + desktop facet forms, but strip any existing tag params
      if (
        form.id === 'FacetSortForm' ||
        form.id === 'FacetFiltersForm' ||
        form.id === 'FacetSortDrawerForm'
      ) {
        const fd = new FormData(form);
        const stripped = new URLSearchParams(
          [...new URLSearchParams(fd).entries()].filter(([k]) => k !== this.tagParam)
        );
        if (stripped.toString()) parts.push(stripped.toString());
      }
    });

    // Append our tag selections
    this._selectedTags.forEach((tag) => {
      parts.push(`${encodeURIComponent(this.tagParam)}=${encodeURIComponent(tag)}`);
    });

    const searchParams = parts.join('&');
    FacetFiltersForm.renderPage(searchParams, null, true);
  }

  renderActiveTags() {
    const wrap = document.getElementById('active-filters-wrap');
    if (!wrap) return;

    // Remove only our tag pills (leave other filters' pills alone)
    wrap.querySelectorAll('.tfd-active-tag').forEach((el) => el.remove());

    this._selectedTags.forEach((tag) => {
      const pill = document.createElement('div');
      pill.className = 'tfd-active-tag';
      pill.innerHTML = `
        <button type="button" aria-label="Remove ${tag}">
          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"> <g clip-path="url(#clip0_1_173)"> <path d="M9.64286 0.357147L0.357147 9.64286" stroke="black" stroke-linecap="round" stroke-linejoin="round"/> <path d="M0.357147 0.357147L9.64286 9.64286" stroke="black" stroke-linecap="round" stroke-linejoin="round"/> </g> <defs> <clipPath id="clip0_1_173"> <rect width="10" height="10" fill="white"/> </clipPath> </defs> </svg>
        </button>
        <span>${tag}</span>
      `;
      pill.querySelector('button').addEventListener('click', () => {
        this.toggleTag(tag);
      });
      wrap.appendChild(pill);
    });
  }

  // ─── Toggle a tag ────────────────────────────────────────────────────────
  toggleTag(tag) {
    if (this._selectedTags.has(tag)) {
      this._selectedTags.delete(tag);
    } else {
      this._selectedTags.add(tag);
    }
    this.updateUI();
    this.applyFilters();
  }

  clearAll() {
    this._selectedTags.clear();
    this.updateUI();
    this.applyFilters();
  }

  // ─── Open / close ────────────────────────────────────────────────────────
  toggle() {
    this._open ? this.close() : this.open();
  }

  open() {
    this._open = true;
    this.querySelector('.tfd-trigger').setAttribute('aria-expanded', 'true');
    this.querySelector('.tfd-panel').classList.add('open');
    // Small delay so this listener doesn't fire immediately on the opening click
    setTimeout(() => document.addEventListener('click', this.handleOutsideClick), 0);
  }

  close() {
    this._open = false;
    this.querySelector('.tfd-trigger').setAttribute('aria-expanded', 'false');
    this.querySelector('.tfd-panel').classList.remove('open');
    document.removeEventListener('click', this.handleOutsideClick);
  }

  handleOutsideClick(e) {
    if (!this.contains(e.target)) this.close();
  }

  // ─── Refresh pill states + counter badge ────────────────────────────────
  updateUI() {
    const count = this._selectedTags.size;

    this.querySelectorAll('.tfd-pill').forEach((pill) => {
      pill.classList.toggle('selected', this._selectedTags.has(pill.dataset.tag));
    });

    this.querySelector('.tfd-clear').style.display = count > 0 ? 'block' : 'none';

    this.renderActiveTags();
  }

  // ─── Config: override via attribute ──────────────────────────────────────
  get tagParam() {
    return this.getAttribute('param') || 'filter.p.tag';
  }

  // ─── Initial render ──────────────────────────────────────────────────────
  render() {
    const tagsAttr = this.getAttribute('tags') || '[]';
    const tags = JSON.parse(tagsAttr);

    const pillsHTML = tags
      .map(
        (tag) => `
        <button class="tfd-pill" data-tag="${tag}" type="button">
          ${tag}
        </button>`
      )
      .join('');

    this.innerHTML = `
      <button class="tfd-trigger" type="button" aria-expanded="false" aria-haspopup="true">
        <span class="tfd-trigger-label">${this.getAttribute('label') || 'Tags'}</span>
      </button>
      <div class="tfd-panel" role="listbox" aria-multiselectable="true">
        <div class="tfd-panel-wrapper">
          <div class="tfd-pills">
            <button class="tfd-pills-close">
              <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 5L5 19M5.00001 5L19 19" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            ${pillsHTML}
          </div>
          <div class="tfd-footer">
            <button class="tfd-clear" type="button" style="display:none">Clear all</button>
          </div>
        </div>
      </div>
    `;

    // Delegate pill clicks
    this.querySelector('.tfd-pills').addEventListener('click', (e) => {
      const pill = e.target.closest('.tfd-pill');
      if (pill) this.toggleTag(pill.dataset.tag);
    });
  }
}

customElements.define('tags-filter-dropdown', TagsFilterDropdown);




document.addEventListener('DOMContentLoaded', () => {

  const decodeHTML = (htmlString) => {
    let tempDiv = document.createElement('div'); 
    tempDiv.innerHTML = htmlString; 
    let decodedHTML = tempDiv.textContent || tempDiv.innerText;
    return decodedHTML;
  };

  const populateList = (container, items) => { 
    if (!container) return;
    container.innerHTML = '';

    items.forEach(item => {
      const li = document.createElement('li');
      const parts = item.split('|').map(part => part.trim());
      const first = parts[0] || ''; 
      const last = parts[1] || '';
      li.innerHTML = `<span>${first}</span><span>${last}</span>`;
      
      container.appendChild(li);
    });
  };

  const populateBenefits = (container, benefits) => {
    if (!container) return;
    container.innerHTML = '';
    benefits.forEach(benefit => {
      const p = document.createElement('div');
      p.classList.add('benifit_box');
      let benifitHTML = `<img src="${benefit.icon}" width="30" height="30" /><div class="benifit-text"><h4>${benefit.title}</h4><p>${benefit.short_description}</p></div>`;
      p.innerHTML = benifitHTML;
      container.appendChild(p);
    });
  };

  const populateAvec = (container, avecs) => {
    if (!container) return;
    container.innerHTML = '';
    avecs.forEach(avec => {
      const p = document.createElement('div');
      p.classList.add('avecs');
      p.innerHTML = `<img src="${avec.icon}" width="30" height="30" /><div class="avecs-details"><h4>${avec.title}</h4><p>${avec.tagline}</p></div>`;
      container.appendChild(p);
    });
  };

  const populateTags = (container, tags) => {
    if (!container) return;
    container.innerHTML = '';
    tags.forEach(tag => {
      console.log(tag);
      const p = document.createElement('li');
      p.textContent = tag.name;
      container.appendChild(p);
    });
  };

  const populateImage = (container, src, alt, className) => {
    if (!container) return;
    container.innerHTML = '';
    const img = document.createElement('img');
    img.src = src;
    img.alt = alt;
    img.className = className;
    container.appendChild(img);
  };

  const setTextContent = (container, text) => {
    if (!container) return;
    container.textContent = text;
  };

  const setHTMLContent = (container, html) => {
    if (!container) return;
    container.innerHTML = decodeHTML(html);
  };

  const openPopup = (jsonData) => {

    const elements = {
      name: document.querySelector('.product-popup-card__name'),
      tags: document.querySelector('.product-popup-card__tags'),
      nutritionList: document.querySelector('#popup-nutrition'),
      bref: document.querySelector('#popup-bref'),
      imageContainer: document.querySelector('#popup-pdp-image'),
      benefitsContainer: document.querySelector('#popup-benefits'),
      tradition: document.querySelector('#popup-tradition'),
      indications: document.querySelector('#popup-indications'),
      avec: document.querySelector('#popup-avec'),
      wrapper: document.querySelector('.product-popup-card-wrapper'),
      button: document.querySelector('.product-popup-card__link')
    };

    if (!elements.wrapper) return;

    setHTMLContent(elements.name, jsonData.title);
    populateList(elements.nutritionList, jsonData.nutrition);

    setHTMLContent(elements.bref, jsonData.bref);
    setHTMLContent(elements.tradition, jsonData.tradition);
    setHTMLContent(elements.indications, jsonData.contre_indications);
    
    populateTags(elements.tags, jsonData.tags);
    populateAvec(elements.avec, jsonData.associer_avec);
    populateBenefits(elements.benefitsContainer, jsonData.benefices_prouves);
    populateImage(elements.imageContainer, jsonData.image, 'Product image', 'product-popup-card__icon');

    elements.button.href = jsonData.url;

    elements.wrapper.classList.add('is-active');
    document.body.classList.add('popup-active');

  };

  const closePopup = () => {
    const wrapper = document.querySelector('.product-popup-card-wrapper');
    if (wrapper) wrapper.classList.remove('is-active');
    document.body.classList.remove('popup-active');
  };

  const closeButton = document.querySelector('#pdp-close-button');
  if (closeButton) closeButton.addEventListener('click', closePopup);

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('.trigger'); // works even if a child element inside trigger is clicked
    if (!trigger) return;

    const dataJson = trigger.getAttribute('data-json');
    if (!dataJson) return;

    let jsonData;
    try {
      jsonData = JSON.parse(dataJson);
    } catch (err) {
      console.error('Invalid JSON in data-json attribute:', err);
      return;
    }
    openPopup(jsonData);
  });

});